import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: var(--modalOverlay);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: var(--z-modal);
`;

export default Overlay;
